function r(r,e){return r.reduce(((r,n)=>{const t=e(n);return void 0===t||(r[t]||(r[t]=[]),r[t].push(n)),r}),{})}export{r as groupBy};
//# sourceMappingURL=groupBy.js.map
